import { render, staticRenderFns } from "./platformAccountForm.vue?vue&type=template&id=55a11aba&scoped=true"
import script from "./platformAccountForm.vue?vue&type=script&lang=js"
export * from "./platformAccountForm.vue?vue&type=script&lang=js"
import style0 from "./platformAccountForm.vue?vue&type=style&index=0&id=55a11aba&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a11aba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-OA/jh-oa-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55a11aba')) {
      api.createRecord('55a11aba', component.options)
    } else {
      api.reload('55a11aba', component.options)
    }
    module.hot.accept("./platformAccountForm.vue?vue&type=template&id=55a11aba&scoped=true", function () {
      api.rerender('55a11aba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/assetManagement/common/platformAccountForm.vue"
export default component.exports